import Themes from 'shared/editor/generic/Themes';
import Customize from './../components/Customize';
import Template from './../components/Template';
import Data from '../components/Data';
import { PanelOptionProps } from '../../../shared/editor/generic/OptionsPanel';

const options: Array<PanelOptionProps> = [
  {
    id: 'data',
    name: 'Data',
    element: Data as unknown as React.ReactNode
  },
  {
    id: 'type',
    name: 'Types',
    element: Template as unknown as React.ReactNode,
    permission: 'template',
    mapDisabled: true
  },
  {
    id: 'themes',
    name: 'Themes',
    element: Themes as unknown as React.ReactNode,
    permission: 'themes'
  },
  {
    id: 'customize',
    name: 'Customize',
    element: Customize as unknown as React.ReactNode,
    permission: 'customize'
  }
];

export default options;
